var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switcher",class:{'checked': _vm.value},on:{"click":_vm.switchValue}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switcher_container flex middle-xs"},[_c('div',{staticClass:"switcher_thumb"})])
}]

export { render, staticRenderFns }